const CURRENCIES = {
  AED: {
    code: "AED",
    currency: "UAE Dirham",
    decimals: 2
  },
  ALL: {
    code: "ALL",
    currency: "Albanian Lek",
    decimals: 2
  },
  AMD: {
    code: "AMD",
    currency: "Armenian Dram",
    decimals: 2
  },
  ANG: {
    code: "ANG",
    currency: "Antillian Guilder",
    decimals: 2
  },
  AOA: {
    code: "AOA",
    currency: "Angolan Kwanza",
    decimals: 2
  },
  ARS: {
    code: "ARS",
    currency: "Nuevo Argentine Peso",
    decimals: 2
  },
  AUD: {
    code: "AUD",
    currency: "Australian Dollar",
    decimals: 2
  },
  AWG: {
    code: "AWG",
    currency: "Aruban Guilder",
    decimals: 2
  },
  AZN: {
    code: "AZN",
    currency: "Azerbaijani manat",
    decimals: 2
  },
  BAM: {
    code: "BAM",
    currency: "Bosnia and Herzegovina Convertible Marks",
    decimals: 2
  },
  BBD: {
    code: "BBD",
    currency: "Barbados Dollar",
    decimals: 2
  },
  BDT: {
    code: "BDT",
    currency: "Bangladesh Taka",
    decimals: 2
  },
  BGN: {
    code: "BGN",
    currency: "New Bulgarian Lev",
    decimals: 2
  },
  BHD: {
    code: "BHD",
    currency: "Bahraini Dinar",
    decimals: 3
  },
  BMD: {
    code: "BMD",
    currency: "Bermudian Dollar",
    decimals: 2
  },
  BND: {
    code: "BND",
    currency: "Brunei Dollar",
    decimals: 2
  },
  BOB: {
    code: "BOB",
    currency: "Bolivia Boliviano",
    decimals: 2
  },
  BRL: {
    code: "BRL",
    currency: "Brazilian Real",
    decimals: 2
  },
  BSD: {
    code: "BSD",
    currency: "Bahamian Dollar",
    decimals: 2
  },
  BTC: {
    code: "BTC",
    currency: "Bitcoin",
    decimals: 8
  },
  BWP: {
    code: "BWP",
    currency: "Botswana Pula",
    decimals: 2
  },
  BZD: {
    code: "BZD",
    currency: "Belize Dollar",
    decimals: 2
  },
  CAD: {
    code: "CAD",
    currency: "Canadian Dollar",
    decimals: 2
  },
  CHF: {
    code: "CHF",
    currency: "Swiss Franc",
    decimals: 2
  },
  CLP: {
    code: "CLP",
    currency: "Chilean Peso",
    decimals: 0
  },
  CNY: {
    code: "CNY",
    currency: "Yuan Renminbi",
    decimals: 2
  },
  COP: {
    code: "COP",
    currency: "Colombian Peso",
    decimals: 2
  },
  CRC: {
    code: "CRC",
    currency: "Costa Rican Colon",
    decimals: 2
  },
  CUP: {
    code: "CUP",
    currency: "Cuban Peso",
    decimals: 2
  },
  CVE: {
    code: "CVE",
    currency: "Cape Verdi Escudo",
    decimals: 0
  },
  CZK: {
    code: "CZK",
    currency: "Czech Koruna",
    decimals: 2
  },
  DJF: {
    code: "DJF",
    currency: "Djibouti Franc",
    decimals: 0
  },
  DKK: {
    code: "DKK",
    currency: "Danish Krone",
    decimals: 2
  },
  DOP: {
    code: "DOP",
    currency: "Dominican Republic Peso",
    decimals: 2
  },
  DZD: {
    code: "DZD",
    currency: "Algerian Dinar",
    decimals: 2
  },
  EGP: {
    code: "EGP",
    currency: "Egyptian Pound",
    decimals: 2
  },
  ETB: {
    code: "ETB",
    currency: "Ethiopian Birr",
    decimals: 2
  },
  EUR: {
    code: "EUR",
    currency: "Euro",
    decimals: 2
  },
  FJD: {
    code: "FJD",
    currency: "Fiji Dollar",
    decimals: 2
  },
  FKP: {
    code: "FKP",
    currency: "Falkland Islands Pound",
    decimals: 2
  },
  GBP: {
    code: "GBP",
    currency: "Pound Sterling",
    decimals: 2
  },
  GEL: {
    code: "GEL",
    currency: "Georgian Lari",
    decimals: 2
  },
  GHS: {
    code: "GHS",
    currency: "Ghanaian Cedi (3rd)",
    decimals: 2
  },
  GIP: {
    code: "GIP",
    currency: "Gibraltar Pound",
    decimals: 2
  },
  GMD: {
    code: "GMD",
    currency: "Gambia Delasi",
    decimals: 2
  },
  GNF: {
    code: "GNF",
    currency: "Guinea Franc",
    decimals: 0
  },
  GTQ: {
    code: "GTQ",
    currency: "Guatemala Quetzal",
    decimals: 2
  },
  GYD: {
    code: "GYD",
    currency: "Guyanese Dollar",
    decimals: 2
  },
  HKD: {
    code: "HKD",
    currency: "Hong Kong Dollar",
    decimals: 2
  },
  HNL: {
    code: "HNL",
    currency: "Honduras Lempira",
    decimals: 2
  },
  HRK: {
    code: "HRK",
    currency: "Croatia Kuna",
    decimals: 2
  },
  HTG: {
    code: "HTG",
    currency: "Haitian Gourde",
    decimals: 2
  },
  HUF: {
    code: "HUF",
    currency: "Hungarian Forint",
    decimals: 2
  },
  IDR: {
    code: "IDR",
    currency: "Indonesian Rupiah",
    decimals: 0
  },
  ILS: {
    code: "ILS",
    currency: "New Israeli Scheqel",
    decimals: 2
  },
  INR: {
    code: "INR",
    currency: "Indian Rupee",
    decimals: 2
  },
  IQD: {
    code: "IQD",
    currency: "Iraqi Dinar",
    decimals: 3
  },
  ISK: {
    code: "ISK",
    currency: "Iceland Krona",
    decimals: 0
  },
  JMD: {
    code: "JMD",
    currency: "Jamaican Dollar",
    decimals: 2
  },
  JOD: {
    code: "JOD",
    currency: "Jordanian Dinar",
    decimals: 3
  },
  JPY: {
    code: "JPY",
    currency: "Japanese Yen",
    decimals: 0
  },
  KES: {
    code: "KES",
    currency: "Kenyan Shilling",
    decimals: 2
  },
  KGS: {
    code: "KGS",
    currency: "Kyrgyzstan Som",
    decimals: 2
  },
  KHR: {
    code: "KHR",
    currency: "Cambodia Riel",
    decimals: 2
  },
  KMF: {
    code: "KMF",
    currency: "Comoro Franc",
    decimals: 0
  },
  KRW: {
    code: "KRW",
    currency: "South-Korean Won",
    decimals: 0
  },
  KWD: {
    code: "KWD",
    currency: "Kuwaiti Dinar",
    decimals: 3
  },
  KYD: {
    code: "KYD",
    currency: "Cayman Islands Dollar",
    decimals: 2
  },
  KZT: {
    code: "KZT",
    currency: "Kazakhstani Tenge",
    decimals: 2
  },
  LAK: {
    code: "LAK",
    currency: "Laos Kip",
    decimals: 2
  },
  LBP: {
    code: "LBP",
    currency: "Lebanese Pound",
    decimals: 2
  },
  LKR: {
    code: "LKR",
    currency: "Sri Lanka Rupee",
    decimals: 2
  },
  LYD: {
    code: "LYD",
    currency: "Libyan Dinar",
    decimals: 3
  },
  MAD: {
    code: "MAD",
    currency: "Moroccan Dirham",
    decimals: 2
  },
  MDL: {
    code: "MDL",
    currency: "Moldovia Leu",
    decimals: 2
  },
  MGA: {
    code: "MGA",
    currency: "Malagasy Ariary",
    decimals: 0
  },
  MKD: {
    code: "MKD",
    currency: "Macedonian Denar",
    decimals: 2
  },
  MMK: {
    code: "MMK",
    currency: "Myanmar Kyat",
    decimals: 2
  },
  MNT: {
    code: "MNT",
    currency: "Mongolia Tugrik",
    decimals: 2
  },
  MOP: {
    code: "MOP",
    currency: "Macau Pataca",
    decimals: 2
  },
  MRO: {
    code: "MRO",
    currency: "Mauritanian Ouguiya",
    decimals: 0
  },
  MUR: {
    code: "MUR",
    currency: "Mauritius Rupee",
    decimals: 2
  },
  MVR: {
    code: "MVR",
    currency: "Maldives Rufiyaa",
    decimals: 2
  },
  MWK: {
    code: "MWK",
    currency: "Malawi Kwacha",
    decimals: 2
  },
  MXN: {
    code: "MXN",
    currency: "Mexican Peso",
    decimals: 2
  },
  MYR: {
    code: "MYR",
    currency: "Malaysian Ringgit",
    decimals: 2
  },
  MZN: {
    code: "MZN",
    currency: "Mozambican Metical",
    decimals: 2
  },
  NAD: {
    code: "NAD",
    currency: "Namibian Dollar",
    decimals: 2
  },
  NGN: {
    code: "NGN",
    currency: "Nigerian Naira",
    decimals: 2
  },
  NIO: {
    code: "NIO",
    currency: "Nicaragua Cordoba Oro",
    decimals: 2
  },
  NOK: {
    code: "NOK",
    currency: "Norwegian Krone",
    decimals: 2
  },
  NPR: {
    code: "NPR",
    currency: "Nepalese Rupee",
    decimals: 2
  },
  NZD: {
    code: "NZD",
    currency: "New Zealand Dollar",
    decimals: 2
  },
  OMR: {
    code: "OMR",
    currency: "Rial Omani",
    decimals: 3
  },
  PAB: {
    code: "PAB",
    currency: "Panamanian Balboa",
    decimals: 2
  },
  PEN: {
    code: "PEN",
    currency: "Peruvian Nuevo Sol",
    decimals: 2
  },
  PGK: {
    code: "PGK",
    currency: "New Guinea Kina",
    decimals: 2
  },
  PHP: {
    code: "PHP",
    currency: "Philippine Peso",
    decimals: 2
  },
  PKR: {
    code: "PKR",
    currency: "Pakistan Rupee",
    decimals: 2
  },
  PLN: {
    code: "PLN",
    currency: "New Polish Zloty",
    decimals: 2
  },
  PYG: {
    code: "PYG",
    currency: "Paraguay Guarani",
    decimals: 0
  },
  QAR: {
    code: "QAR",
    currency: "Qatari Rial",
    decimals: 2
  },
  RON: {
    code: "RON",
    currency: "New Romanian Lei",
    decimals: 2
  },
  RSD: {
    code: "RSD",
    currency: "Serbian Dinar",
    decimals: 2
  },
  RUB: {
    code: "RUB",
    currency: "Russian Ruble",
    decimals: 2
  },
  RWF: {
    code: "RWF",
    currency: "Rwanda Franc",
    decimals: 0
  },
  SAR: {
    code: "SAR",
    currency: "Saudi Riyal",
    decimals: 2
  },
  SBD: {
    code: "SBD",
    currency: "Solomon Island Dollar",
    decimals: 2
  },
  SCR: {
    code: "SCR",
    currency: "Seychelles Rupee",
    decimals: 2
  },
  SEK: {
    code: "SEK",
    currency: "Swedish Krone",
    decimals: 2
  },
  SGD: {
    code: "SGD",
    currency: "Singapore Dollar",
    decimals: 2
  },
  SHP: {
    code: "SHP",
    currency: "St. Helena Pound",
    decimals: 2
  },
  SOS: {
    code: "SOS",
    currency: "Somalia Shilling",
    decimals: 2
  },
  SRD: {
    code: "SRD",
    currency: "Surinamese dollar",
    decimals: 2
  },
  SVC: {
    code: "SVC",
    currency: "El Salvador Colón",
    decimals: 2
  },
  SZL: {
    code: "SZL",
    currency: "Swaziland Lilangeni",
    decimals: 2
  },
  THB: {
    code: "THB",
    currency: "Thai Baht",
    decimals: 2
  },
  TND: {
    code: "TND",
    currency: "Tunisian Dinar",
    decimals: 3
  },
  TOP: {
    code: "TOP",
    currency: "Tonga Pa'anga",
    decimals: 2
  },
  TRY: {
    code: "TRY",
    currency: "New Turkish Lira",
    decimals: 2
  },
  TTD: {
    code: "TTD",
    currency: "Trinidad &amp; Tobago Dollar",
    decimals: 2
  },
  TWD: {
    code: "TWD",
    currency: "New Taiwan Dollar",
    decimals: 2
  },
  TZS: {
    code: "TZS",
    currency: "Tanzanian Shilling",
    decimals: 2
  },
  UAH: {
    code: "UAH",
    currency: "Ukraine Hryvnia",
    decimals: 2
  },
  UGX: {
    code: "UGX",
    currency: "Uganda Shilling",
    decimals: 0
  },
  USD: {
    code: "USD",
    currency: "US Dollars",
    decimals: 2
  },
  UYU: {
    code: "UYU",
    currency: "Peso Uruguayo",
    decimals: 2
  },
  UZS: {
    code: "UZS",
    currency: "Uzbekistani Som",
    decimals: 2
  },
  VEF: {
    code: "VEF",
    currency: "Venezuelan Bolívar",
    decimals: 2
  },
  VND: {
    code: "VND",
    currency: "Vietnamese New Dong",
    decimals: 0
  },
  VUV: {
    code: "VUV",
    currency: "Vanuatu Vatu",
    decimals: 0
  },
  WST: {
    code: "WST",
    currency: "Samoan Tala",
    decimals: 2
  },
  XAF: {
    code: "XAF",
    currency: "CFA Franc BEAC",
    decimals: 0
  },
  XCD: {
    code: "XCD",
    currency: "East Caribbean Dollar",
    decimals: 2
  },
  XOF: {
    code: "XOF",
    currency: "CFA Franc BCEAO",
    decimals: 0
  },
  XPF: {
    code: "XPF",
    currency: "CFP Franc",
    decimals: 0
  },
  YER: {
    code: "YER",
    currency: "Yemeni Rial",
    decimals: 2
  },
  ZAR: {
    code: "ZAR",
    currency: "South African Rand",
    decimals: 2
  },
  ZMW: {
    code: "ZMW",
    currency: "Zambian Kwacha",
    decimals: 2
  }
};
export {
  CURRENCIES
};
//# sourceMappingURL=currencies.js.map
